/**
 * LiteFunnel — /valuation
 *
 * Orchestrates the public lite funnel:
 *   - Renders LiteWizard until onComplete(valuationId) is called
 *   - Then renders EmailGate with the returned valuationId
 */

import React, { useState } from 'react';
import LiteWizard from '../components/lite/LiteWizard';
import EmailGate from '../components/lite/EmailGate';

function LiteFunnel() {
  const [valuationId, setValuationId] = useState(null);

  return valuationId ? (
    <EmailGate valuationId={valuationId} />
  ) : (
    <LiteWizard onComplete={setValuationId} />
  );
}

export default LiteFunnel;
